import React from 'react'
import type { RenderableItem } from '@paintscout/util/builder'
import { Typography, makeStyles } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'

const useStyles = makeStyles((theme: Theme) => ({
  value: {
    fontWeight: theme.typography.fontWeightMedium,
    '& p': {
      fontWeight: theme.typography.fontWeightMedium
    }
  }
}))

export default function AmountColumn({
  item,
  consumer,
  showBackup
}: {
  consumer: string
  item: RenderableItem
  showBackup?: boolean
}) {
  const classes = useStyles({})

  const value = showBackup
    ? item.value || (consumer === 'crew' ? item.additionalFields?.hours : item.additionalFields?.price)
    : item.value

  return (
    <Typography
      value={value as unknown as number}
      showUnits
      component="span"
      format={consumer === 'crew' ? 'hours' : 'price'}
      variant={'body1'}
      classes={{ root: classes.value }}
    />
  )
}
